import { useQuery } from '@tanstack/react-query';
import { BondProviderApi } from 'api';

/**
 * Custom React Query hook to fetch bond providers list.
 *
 * @param {{ onError?: (error: Error) => void }} callbacks
 * @returns {import("@tanstack/react-query").UseQueryResult<any, Error>}
 */
export function useGetBondProviders({ onError } = {}) {
  return useQuery({
    queryKey: ['bond-providers'],
    queryFn: () =>
      BondProviderApi.get()
        .then((res) => res.data)
        .catch((error) => {
          typeof onError === 'function' && onError(error);
        }),
    staleTime: Infinity,
    placeholderData: [],
  });
}
